export default __webpack_public_path__ + "static/media/anonymous-dog.4d7773fa.png";